import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { route } from "../../router/route";

import PretendardText from "../atoms/text/pretendardText";
import InputSearch from "../atoms/input/inputSearch";

import { headerMenuState, headerTriggerState } from "../../store/headerState";

import LSRgH1HeadLine from "../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBorderBtn from "../atoms/button/mainBorderBtn";
import LSRgBody02 from "../molecules/text/linSeedKr/Rg/lsRgBody02";
import { fileUrl } from "../../api/api";
import AuthApi from "../../api/auth.api";

const HeaderM = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const inputRef = useRef(null); // Input 요소 참조 생성
  const containerRef = useRef(null);

  const headerTriggerStateAtom = useRecoilValue(headerTriggerState);
  const headerMenuStateAtom = useRecoilValue(headerMenuState);

  const [isSecondOpen, setIsSecondOpen] = useState(-1);

  const [keyword, setKeyword] = useState("");
  const [isMenuOn, setIsMenuOn] = useState(false);

  const [isLogin, setIsLogin] = useState(false);
  const [name, setName] = useState("");
  const [profile, setProfile] = useState("");

  useEffect(() => {
    let isLogin = sessionStorage.getItem("isLogin");
    let name = sessionStorage.getItem("name");
    let profile = sessionStorage.getItem("profile");

    setIsLogin(isLogin === "true");
    setName(name);
    setProfile(profile);
  }, [pathname, headerTriggerStateAtom]);

  const logoutFunc = async () => {
    try {
      await AuthApi.logout();
    } finally {
      sessionStorage.clear();
      window.location.href = route.login;
    }
  };

  const searchLecture = () => {
    const normalizedKeyword = keyword.trim();
    if (!normalizedKeyword) return;

    setIsMenuOn(false);
    navigate(
      `${route.search}?page=1&keyword=${encodeURIComponent(normalizedKeyword)}`,
    );
    setKeyword("");
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOn(false);
      }
    };
    window.addEventListener("mousedown", handleClick);
    return () => window.removeEventListener("mousedown", handleClick);
  }, [containerRef]);

  return (
    <HeaderMSection>
      <HeaderMWrapper>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <img
            onClick={() => {
              setIsMenuOn(true);
            }}
            style={{
              width: 18,
              height: 18,
              cursor: "pointer",
              marginRight: 16,
            }}
            src={"/assets/icons/menu.png"}
            alt="menu"
          />

          <img
            onClick={() => {
              navigate(`${route.home}`);
            }}
            style={{
              width: 86,
              height: 18,
              cursor: "pointer",
            }}
            src="/assets/icons/logoh.png"
            alt="logoh"
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <img
            onClick={() => {
              setIsMenuOn(true);

              setTimeout(() => {
                inputRef.current?.focus(); // InputSearch에 포커스 설정
              }, 200); // 약간의 지연시간 추가
            }}
            style={{
              width: 18,
              height: 18,
              cursor: "pointer",
            }}
            src="/assets/icons/search.png"
            alt="search"
          />
        </div>
      </HeaderMWrapper>

      {isMenuOn ? (
        <SubHeaderWrapper>
          <SubHeaderContainer ref={containerRef}>
            <div
              style={{
                padding: "29px 20px 25px 20px",
                background: "#EDEDFF80",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <img
                  onClick={() => {
                    navigate(`${route.home}`);
                    setIsMenuOn(false);
                  }}
                  src="/assets/icons/logoh.png"
                  alt=""
                  style={{
                    width: 125,
                    height: 27.58,
                    cursor: "pointer",
                  }}
                />
                <img
                  src="/assets/icons/ic-closed-30.png"
                  alt="closed-30"
                  style={{
                    width: 30,
                    height: 30,
                    cursor: "pointer",
                  }}
                  onClick={() => setIsMenuOn(false)}
                />
              </div>

              {isLogin ? (
                <div
                  onClick={() => {
                    navigate(route.my_page_setting);
                    setIsMenuOn(false);
                  }}
                  style={{
                    marginBottom: 22,
                    marginTop: 35,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={
                      profile && profile !== "null"
                        ? `${fileUrl}/${profile}`
                        : "/assets/icons/profile.png"
                    }
                    alt="profile"
                    style={{
                      height: 30,
                      width: 30,
                      marginRight: 4,
                    }}
                  />
                  <LSRgBody02
                    style={{
                      color: "#101113",
                    }}
                  >
                    {name}님
                  </LSRgBody02>
                </div>
              ) : (
                <div
                  style={{
                    marginBottom: 14,
                    marginTop: 28,
                  }}
                >
                  <MainBorderBtn
                    onClick={() => {
                      navigate(route.login);
                      setIsMenuOn(false);
                    }}
                    style={{
                      height: 45,
                      borderRadius: 8,
                      background: "transparent",
                    }}
                  >
                    <LSRgBody02
                      style={{
                        color: "#5050FF",
                        textAlign: "center",
                      }}
                    >
                      로그인
                    </LSRgBody02>
                  </MainBorderBtn>
                </div>
              )}

              <InputSearch
                ref={inputRef} // Input에 ref 연결
                style={{
                  background: "#ffffff",
                  height: 45,
                }}
                placeholder={"강의명"}
                value={keyword}
                onChange={(value) => {
                  setKeyword(value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                    searchLecture();
                  }
                }}
                searchStyle={{}}
                setDataToKeyword={() => {
                  searchLecture();
                }}
              />
            </div>

            <div>
              {headerMenuStateAtom.map((item, index) => {
                return item.activation ? (
                  <React.Fragment key={item.title}>
                    <MenuWrapper
                      onClick={() => {
                        if (item.childCategories.length > 0) {
                          if (isSecondOpen === index) {
                            setIsSecondOpen(-1);
                          } else {
                            setIsSecondOpen(index);
                          }

                          return;
                        }

                        setIsMenuOn(false);
                        if (item.src) {
                          navigate(item.src);
                        }
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Menu $active={isSecondOpen === index}>{item.title}</Menu>
                      {item.childCategories.length > 0 ? (
                        <img
                          className={
                            isSecondOpen === index ? "rotate" : "rotate-back"
                          }
                          src={"/assets/icons/menu_down.png"}
                          alt=""
                          onClick={() => {
                            if (isSecondOpen === index) {
                              setIsSecondOpen(-1);
                            } else {
                              setIsSecondOpen(index);
                            }
                          }}
                          style={{
                            width: 28,
                            height: 28,
                            cursor: "pointer",
                          }}
                        />
                      ) : null}
                    </MenuWrapper>

                    {isSecondOpen === index && item.childCategories
                      ? item.childCategories?.map((item2) => {
                          return item2.activation ? (
                            <React.Fragment key={item2.id ?? item2.title}>
                              <SecondMenuWrapper
                                $active={
                                  item2.src === pathname ||
                                  item2.link === pathname
                                }
                                onClick={() => {
                                  if (item2.src) {
                                    navigate(item2.src);
                                  } else {
                                    navigate(
                                      `${item.src}?page=1&categoryValue=${item2.id}`,
                                    );
                                  }

                                  setIsMenuOn(false);
                                }}
                              >
                                <SecondMenu
                                  $active={
                                    item2.src === pathname ||
                                    item2.link === pathname
                                  }
                                >
                                  {item2.title}
                                </SecondMenu>
                              </SecondMenuWrapper>
                            </React.Fragment>
                          ) : null;
                        })
                      : null}
                  </React.Fragment>
                ) : null;
              })}
            </div>

            {isLogin && (
              <div
                onClick={() => {
                  setIsMenuOn(false);
                  logoutFunc();
                }}
                style={{
                  margin: "20px 20px",
                  cursor: "pointer",
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#A4A8B1",
                    textDecoration: "underline",
                  }}
                >
                  로그아웃
                </LSRgH1HeadLine>
              </div>
            )}
          </SubHeaderContainer>
        </SubHeaderWrapper>
      ) : null}
    </HeaderMSection>
  );
};

export default HeaderM;

const HeaderMSection = styled.div`
  position: sticky;
  top: 0;
  z-index: 98;

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /* border-bottom: 1px solid #dcdcdc; */
`;

const HeaderMWrapper = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 0px 20px;
`;

const SubHeaderWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  overflow-y: auto;
`;

const SubHeaderContainer = styled.div`
  position: relative;
  width: 70%;
  min-height: 100%;
  background: #fff;
  padding-bottom: 30px;
  z-index: 10;
`;

const MenuWrapper = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #e8e8e8;
`;

const Menu = styled(PretendardText)`
  font-weight: 500;
  font-size: 16px;
  line-height: 23.2px;
  color: ${(props) => (props.$active ? "#313131" : "#626262")};
  cursor: pointer;
`;

const SecondMenuWrapper = styled.div`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 35px;
  border-bottom: 1px solid #e8e8e8;
  background-color: ${(props) => (props.$active ? "#FFF6FA" : "#fafafa")};
  cursor: pointer;
`;

const SecondMenu = styled(PretendardText)`
  font-weight: 500;
  font-size: 16px;
  line-height: 23.2px;
  color: ${(props) => (props.$active ? "#FF649C" : "#626262")};
  cursor: pointer;
`;
